<template>
    <div class="col-sm-12 list-content nopads p-2 pb-3">
        <span class="card-title">
            {{ $t('team.members') }}
        </span>
        <member-item
                v-for="member in memberList"
                v-bind:key="member.id"
                class="col-12 item-container"
                :member="member"
                :canDelete="true"
                @remove="removeUser"/>
    </div>
</template>

<script>

    import MemberItem from "./MemberItem";
    export default {
        name: "member-list",
        components: {MemberItem},
        props: {
            memberList: {
                type: Array,
                default() {
                    return []
                }
            },
            canDelete: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            removeUser: function (member) {
                this.$emit('removeMember', member.email)
            }
        }
    }
</script>

<style scoped>
</style>
